let GOOGLE_API_LOADED = false;

export const init = () => {
  try {
    if (!GOOGLE_API_LOADED) {
      const onLoad = () => {
        (window as any).gapi.load('picker');
      };
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.src = `https://apis.google.com/js/api.js`;
      scriptElement.onload = onLoad;
      document.head.appendChild(scriptElement);
      GOOGLE_API_LOADED = true;
      const styleElement = document.createElement('style');
      styleElement.innerText = `
        body > .picker {
          z-index: 100000000;
        }`;
      document.head.appendChild(styleElement);
    }
  } catch (e) {}
};

export const showPicker = (
  accessToken: string,
  onSpreadsheetSelected: (
    spreadsheetId: string,
    spreadsheetName: string,
  ) => void,
) => {
  const pickerCallback = (data: google.picker.ResponseObject) => {
    if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
      const docs = data[google.picker.Response.DOCUMENTS];
      if (docs.length >= 1) {
        onSpreadsheetSelected(
          docs[0][google.picker.Document.ID],
          docs[0][google.picker.Document.NAME],
        );
      }
    }
  };
  const docsView = new google.picker.DocsView(
    google.picker.ViewId.SPREADSHEETS,
  ).setMode(google.picker.DocsViewMode.LIST);
  const picker = new google.picker.PickerBuilder()
    .addView(docsView)
    .setOAuthToken(accessToken)
    .setDeveloperKey(GOOGLE_PICKER_API_KEY)
    .setAppId(GOOGLE_CLIENT_ID)
    .setOrigin(
      window.location.ancestorOrigins?.[
        (window.location.ancestorOrigins?.length || 0) - 1
      ] || window.location.origin,
    )
    .setCallback(pickerCallback)
    .build();
  picker.setVisible(true);
};
